/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getFinanceOrderListByCreatedUserId,
    setFinanceMarketCostStatus
} from '@/api/financial-center'

import {getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'
import { Loading } from 'element-ui'

// 金额的校验
const checkAge = (rule, value, callback) => {
    if (value) {
        const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (!reg.test(value)) {
            callback(new Error('请输入数字值！'))
        } else {
            if (value > 2000) {
                callback(new Error("请输入不超过2000的数！"))
            } else {
                callback()
            }
        }
    }
}

@Component({})
export default class MarketCost extends Vue {
    invoiceNumTitle = '订单/回款编号：'  //订单回款编号label
    customerId: number  //客户id
    customerType: string  //客户类型
    marketCooperationId: number  //合作伙伴id
    select = '1'  //回款编号
    options = [
        {label: '客户名称', value: '0'},
        {label: '订单/回款编号', value: '1'},
    ]

    logList = []

    customerNameOrMarketCooperationName = ''



    orderDialog = false  //学生订单列表
    partnersOrderDialog = false  //合作伙伴订单列表
    receivableDialog = false
    orderDialogInputValue = ''
    receivableDialogInputValue = ''
    orderDialogTaleData = []
    receivableDialogTaleData = []
    orderDialogTotal = 0
    receivableDialogTotal = 0
    orderDialogPage = 1
    receivableDialogPage = 1
    orderDialogTableLoading = false
    receivableDialogTableLoading = false
    orderDialogSelectTable = []
    formData = {
        id: '',
        types: '',// 费用类型
        other: '',// 费用类型 --- 输入框
        financeOrderId: '',
        price: '',
        score: '',
        reason: '',  //申请原因
        createdUserRealName: '',
        createdAt: '',
        directorUserRealName: '',
        reward: '0',
    }
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    orderId: number = null
    tableRandom = Math.random()
    feeTypeList = [
        {label: '合作顾问额外奖励', value: '0'},
        {label: '中小顾问积分奖励', value: '1'},
        {label: '学生奖学金申请', value: '2'},
        {label: '市场活动费用', value: '3'},
        {label: '其他', value: '4'}
    ] // 费用类型
    operationShow = true
    backMoneyStatus = ''
    showInput: any = false
    type = ""
    status: any
    costId = NaN
    isUpdatedData = '0'
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    cancelReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    numberlimit = [{validator: checkAge, trigger: "change"}]
    tableDataOrder = [] //明细列表
    formRules = {
        'formData.types': [{required: true, message: '请选择费用类型', trigger: 'change'}],
    }
    disBtn = false
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
    }
    loading = false
    isNotReject = false

    get userName() {
        return UserModule.userName
    }



    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableDataOrder.forEach(item => num += Number(item.priceOrScore))
        return num
    }

    menuBtn = menuBtn
    formatDate = formatDate


    created() {
        this.approval_id = Number(this.$route.query.approval_id)
        this.types = this.$route.query.types as string
        this.getMessageReviewById()
        this.approval_type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
    }

    async getMessageReviewById() {
        this.loading = true
        await getMessageReviewById(this.approval_id, this.types).then((data:any)=>{
            this.tableDataOrder = data.result.financeMarketCostDetailList
            this.formData = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.logList = data.result.messageReviewLogList
            this.stepNode.isFirstNode = data.result.isFirstNode
            this.stepNode.isSyncEkuaibao = data.result.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = data.result.isSyncEqianbao
            this.payInfo = data.result.financeMarketCostAccount
            this.formData.reward = data.result.reward == '非实物' ? '1' : '0'
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    openReviewDialog(status: number){
        this.status = status
        this.approvedVisible = true
    }
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    reviewDialogConfirm() {
        const newObj = this.formData
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            nodeType: this.nodeType,
            isSync: this.isSync,
            // isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
        }
        this.disBtn = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })

        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err)=>{
            this.disBtn = false
            loading.close();
        })
    }

    // 通过
    approvedConfirm() {
        const newObj = this.formData
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            // nodeType: this.nodeType,
            // isSync: this.isSync,
            isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
        }
        this.disBtn = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })

        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err)=>{
            this.disBtn = false
            loading.close();
        })
    }


    // 订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.getCustomerNameListByFinanceMarketCost()
        e.target.blur()
    }

    // 合作伙伴、学生列表
    async getCustomerNameListByFinanceMarketCost() {
        const obj = {
            customerName: this.orderDialogInputValue,
            page: this.orderDialogPage,
            limit: 20,
        }
        const data: any = await getFinanceOrderListByCreatedUserId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
        this.tableRandom = Math.random()
    }



    getRowKeys(row) {
        return `${row.code}`
    }


    // 订单确认事件
    orderDialogConfirm() {
        this.formData.financeOrderId = this.orderDialogSelectTable[0].id
        this.orderDialog = false
    }


    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
    }

    // 订单
    handleOrderRowClick(row) {
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }


    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
    }

    receivableDialogPageChange(page: number) {
        this.receivableDialogPage = page
    }

    closePage() {
        window.close()
    }

    changeTypes() {
        this.formData.score = ''
        this.formData.price = ''
    }
    // 撤回审批
    async cancelApproval() {
        await setFinanceMarketCostStatus({ id: Number(this.formData.id), action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.cancelReview = false
    }
    // 驳回审批
    clickRejectButton(status: number) {
        // this.stepNode.approvalStatus = status
        this.status = status
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.opinion = data.reviewIdea
        this.isSync = data.isTouchE
        this.approvalVisible = false
        this.reviewDialogConfirm()
    }

    /*
  * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.opinion = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }
}
